
<div class="main-content mt-16">
  @if (iconSet()) {
    <div id="clientScopeApp" class="px-4 pb-3 pt-1">
      @if (hasError) {
        <div>
          @if (showNoAccessError) {
            <div>
              <app-no-access-error></app-no-access-error>
            </div>
          } @else {
            <div class="row">
              <div class="col-12">
                <div class="mt-3 dashboard-error">
                  <div>
                    <h3 class="text-center">{{errorMessage}}</h3>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="row mh-42 mx-0">
          <div class="col-12 px-0">
            <div class="lg:mt-4 bread-crumb-container grid lg:col-12 lg:flex mr-3.5 lg:mx-0">
              <div class="col-12 px-0 lg:contents">
                @for (breadcrumb of breadcrumbs; track breadcrumb) {
                  <div class="custom-breadcrumb">
                    <a class="custom-breadcrumb__text" attr.data-cy="breadcrumb{{breadcrumb.type}}"
                      routerLinkActive="active" [routerLink]="breadcrumb.route"
                      [queryParams]="breadcrumb.queryParams"
                      [title]="breadcrumb.name" (click)="breadcrumbClick(breadcrumb)">
                    {{breadcrumb.name}}</a>
                    <mat-icon class="custom-breadcrumb__icon">chevron_right</mat-icon>
                  </div>
                }
              </div>
              <app-auto-adjusting-dropdown [selected]="assetName()"
                [dataForBreadcrumbs]="assetsDataForBreadcrumb" (goToSelected)="goToSelectedAsset($event)"
                [selectedValue]="assetId()" [valueProperty]="'id'"
                [nameProperty]="'name'" [type]="'Assets'"
              data-cy="assetDropdown"></app-auto-adjusting-dropdown>
            </div>
          </div>
        </div>
        <!-- NOTE: Hide reporting period dropdown for now, and will add
        back in when we have asset type specific time series data -->
        <!-- <div class="row mh-42">
        <div class="col-12">
          <div class="flex">
            <div class="asofDates flex ml-auto">
              <div>
                <img src="{{iconSet()['icon.calendar']}}" class="asofDates__icon" />
              </div>
              <select name="asOfDateddl" class="asofDates__as-custom-select" id="asOfDateSel"
                [(ngModel)]="selectedAsOfDate" (change)='updateAsOfDate($event.target.value)'>
                <option *ngFor="let date of asOfDropdownData" [value]="date">
                {{date | dateFormat : 'MM/dd/yyyy'}}</option>
              </select>
            </div>
          </div>
        </div>
      </div> -->
      @if (showAssetNotFound) {
        <div>
          <div class="row">
            <div class="col-12">
              <div class="mt-3 dashboard-error">
                <div>
                  <h3 class="text-center">Asset Not Found</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      } @else {
        <div class="row mh-61 mx-0 mt-4 lg:mt-0 grid grid-cols-1 md:grid-cols-3 lg:px-0">
          <div class="md:col-span-2 lg:px-0">
            <div class="align-middle">
              <div class="asset-title" data-cy="assetTitle">{{assetName()}}</div>
              @if (assetSummary().showAssetUrl) {
                <span class="text-md md:text-lg text-primary underline">
                  <a href="{{assetSummary().assetURL}}" target="_blank"
                    (click)="activityTracking.navigateToAssetUrl('asset dashboard', assetId(), assetName(), assetSummary().assetURL)">
                    {{assetSummary().assetURL}}
                  </a>
                </span>
              }
            </div>
          </div>
        </div>
        @if (isAssetDataUnavailable) {
          <app-data-unavailable-card
            entityLabel="Asset"
            [backRoute]="breadcrumbs[0]?.route"
            [backQueryParams]="breadcrumbs[0]?.queryParams"
            (backClick)="breadcrumbClick(breadcrumbs[0])"
            data-cy="errorCard">
          </app-data-unavailable-card>
        }
        <app-asset-summary [assetType]="assetType" [assetData]="assetData()" [title]="assetName()"
          [summary]="assetSummary().summary" [logo]="assetSummary().logo"
          [slidingImgs]="assetSummary().slidingImgs"></app-asset-summary>
        @if (assetData(); as currentAssetData) {
          <app-financial-summary [assetType]="assetType" [iconSet]="iconSet()" [selectedAsOfDate]="selectedAsOfDate"
            [financialData]="currentAssetData"></app-financial-summary>
        }
        @if (assetType === 'Real Estate' && assetSummary().showMap) {
          <app-map-widget [position]="assetSummary().position"></app-map-widget>
        }
      }
    }
  </div>
}
</div>